// src/components/Modules/Vehicles/OwnerInfo.jsx

import React from "react";
import { Form, Input, Select, Row, Col, Typography } from "antd";
import PropTypes from "prop-types";

const { Option } = Select;
const { Title } = Typography;

const OwnerInfo = ({
  vehicle,
  handleInputChange,
  tiposDocumento,
  departamentos,
  ciudades,
  handleDepartamentoChange,
  errors,
}) => (
  <>
    <Title
      level={4}
      style={{
        backgroundColor: "#0a2e5c",
        color: "white",
        padding: "8px 16px",
        borderRadius: "4px",
        marginTop: 24,
        marginBottom: 16,
      }}
    >
      Datos del Propietario
    </Title>
    <Row gutter={16}>
      {/* Número de Documento */}
      <Col xs={24} sm={12}>
        <Form.Item
          required
          label="Número de Documento"
          validateStatus={errors.propietario_numero_documento ? "error" : ""}
          help={errors.propietario_numero_documento}
        >
          <Input
            name="propietario_numero_documento"
            value={vehicle.propietario_numero_documento}
            onChange={handleInputChange}
          />
        </Form.Item>
      </Col>
      {/* Tipo de Documento */}
      <Col xs={24} sm={12}>
        <Form.Item
          required
          label="Tipo de Documento"
          validateStatus={errors.propietario_tipo_documento_id ? "error" : ""}
          help={errors.propietario_tipo_documento_id}
        >
          <Select
            showSearch // Habilita la búsqueda
            optionFilterProp="children" // Permite filtrar por el texto visible
            value={
              vehicle.propietario_tipo_documento_id
                ? vehicle.propietario_tipo_documento_id
                : undefined
            }
            onChange={(value) =>
              handleInputChange({
                target: { name: "propietario_tipo_documento_id", value },
              })
            }
            placeholder="Seleccione Tipo de Documento"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {tiposDocumento.map((tipo) => (
              <Option key={tipo.id} value={tipo.id}>
                {tipo.descripcion}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      {/* Nombre */}
      <Col xs={24} sm={12}>
        <Form.Item
          required
          label="Nombre"
          validateStatus={errors.propietario_nombre ? "error" : ""}
          help={errors.propietario_nombre}
        >
          <Input
            name="propietario_nombre"
            value={vehicle.propietario_nombre}
            onChange={handleInputChange}
          />
        </Form.Item>
      </Col>
      {/* Teléfono */}
      <Col xs={24} sm={12}>
        <Form.Item
          label="Teléfono"
          validateStatus={errors.propietario_telefono ? "error" : ""}
          help={errors.propietario_telefono}
        >
          <Input
            name="propietario_telefono"
            value={vehicle.propietario_telefono}
            onChange={handleInputChange}
          />
        </Form.Item>
      </Col>
      {/* Correo */}
      <Col xs={24} sm={12}>
        <Form.Item
          label="Correo"
          validateStatus={errors.propietario_correo ? "error" : ""}
          help={errors.propietario_correo}
        >
          <Input
            name="propietario_correo"
            value={vehicle.propietario_correo}
            onChange={handleInputChange}
            type="email"
          />
        </Form.Item>
      </Col>
      {/* Departamento */}
      <Col xs={24} sm={12}>
        <Form.Item
          required
          label="Departamento"
          validateStatus={errors.propietario_departamento ? "error" : ""}
          help={errors.propietario_departamento}
        >
          <Select
            showSearch // Habilita la búsqueda
            optionFilterProp="children" // Permite filtrar por el texto visible
            value={
              vehicle.propietario_departamento
                ? (typeof vehicle.propietario_departamento === 'string' && !isNaN(vehicle.propietario_departamento)
                    ? parseInt(vehicle.propietario_departamento)
                    : vehicle.propietario_departamento)
                : undefined
            }
            onChange={handleDepartamentoChange}
            placeholder="Seleccione Departamento"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {departamentos.map((departamento) => (
              <Option key={departamento.id} value={departamento.id}>
                {departamento.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      {/* Ciudad */}
      <Col xs={24} sm={12}>
        <Form.Item
          required
          label="Ciudad/Municipio"
          validateStatus={errors.propietario_ciudad ? "error" : ""}
          help={errors.propietario_ciudad}
        >
          <Select
            showSearch // Habilita la búsqueda
            optionFilterProp="children" // Permite filtrar por el texto visible
            value={
              vehicle.propietario_ciudad
                ? (typeof vehicle.propietario_ciudad === 'string' && !isNaN(vehicle.propietario_ciudad)
                    ? parseInt(vehicle.propietario_ciudad)
                    : vehicle.propietario_ciudad)
                : undefined
            }
            onChange={(value) =>
              handleInputChange({
                target: { name: "propietario_ciudad", value },
              })
            }
            placeholder="Seleccione Ciudad"
            disabled={!vehicle.propietario_departamento}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {ciudades.map((ciudad) => (
              <Option key={ciudad.id} value={ciudad.id}>
                {ciudad.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      {/* Dirección */}
      <Col xs={24} sm={12}>
        <Form.Item
          label="Dirección"
          validateStatus={errors.propietario_direccion ? "error" : ""}
          help={errors.propietario_direccion}
        >
          <Input
            name="propietario_direccion"
            value={vehicle.propietario_direccion}
            onChange={handleInputChange}
          />
        </Form.Item>
      </Col>
      {/* Barrio */}
      <Col xs={24} sm={12}>
        <Form.Item
          label="Barrio"
          validateStatus={errors.propietario_barrio ? "error" : ""}
          help={errors.propietario_barrio}
        >
          <Input
            name="propietario_barrio"
            value={vehicle.propietario_barrio}
            onChange={handleInputChange}
          />
        </Form.Item>
      </Col>
      {/* Localidad */}
      <Col xs={24} sm={12}>
        <Form.Item
          label="Localidad"
          validateStatus={errors.propietario_localidad ? "error" : ""}
          help={errors.propietario_localidad}
        >
          <Input
            name="propietario_localidad"
            value={vehicle.propietario_localidad}
            onChange={handleInputChange}
          />
        </Form.Item>
      </Col>
    </Row>
  </>
);

OwnerInfo.propTypes = {
  vehicle: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  tiposDocumento: PropTypes.array.isRequired,
  departamentos: PropTypes.array.isRequired,
  ciudades: PropTypes.array.isRequired,
  handleDepartamentoChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

export default OwnerInfo;
